import React from "react"
import FieldProto_ConditionForm from "../../../proto/render/condition/condition-form"
import FieldProto from "../../../proto/field-proto"
import ConditionTypeSelector from "../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";
import FieldRating_MultiselectValueNotEmpty from "../components/multiselect/value-not-empty";
import FieldRating_MultiselectPopoverOption from "../components/multiselect/popover-option";

const debug = false
// const debug = "FieldRating_ConditionForm"

export default class FieldRating_ConditionForm extends FieldProto_ConditionForm {
    render() {
        let field: FieldProto | null | false = null

        debug && console.log(debug, 'render', field)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.condition.value}
                                       //@ts-ignore
                                       valueComponent                   = {(props:any)=><FieldRating_MultiselectValueNotEmpty scale={this.props.field.scale} {...props}/>}
                                       //@ts-ignore
                                       popoverOptionComponent           = {(props:any)=><FieldRating_MultiselectPopoverOption scale={this.props.field.scale} {...props}/>}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       isSearchable                     = {true}
                                       onChange                         = {this.onChangeValue}/>
            </>
        )
    }
}
